{
  "equipment": {
    "add": "Ajouter",
    "equipment": "Équipement",
    "equipmentList": "Liste d'équipements",
    "equipmentDetails": "Détails de l'équipement",
    "viewEquipmentDetails": "Voir les détails de l'équipement",
    "filterEquipment": "Filtrer par Équipement",
    "equipmentActions": "Actions relatives à l'équipement",
    "equipmentUseCase": "Cas d'utilisation de l'équipement",
    "chargingType": "Type de charge",
    "meter": "Compteur",
    "serialVin": "Série / NIV",
    "manufacturer": "Manufacturier",
    "modelYear": "Année de modèle",
    "modelNumber": "Numéro de modèle",
    "unitNo": "Numéro d'unité",
    "meteredKwh": "kWh mesurés",
    "activityStatus": "Statut d'activité",
    "meterType": "Type de compteur",
    "editMetered": "Modifier mesuré",
    "editUnmetered": "Modifier non mesuré",
    "addEquipment": "Ajouter un équipement",
    "viewEquipmentId": "Voir l'ID de l'équipement",
    "save": "Enregistrer",
    "searchBySerial": "Rechercher par numéro de série / NIV",
    "metered": "Mesuré",
    "unmetered": "Non mesuré",
    "updateMeteredEquipmentUsage": "Mettre à jour l'utilisation de l'équipement mesurée",
    "bulkEditAllKwh": "Modifier en bloc tous les kWh mesurés",
    "bulkEditAllKwhHelp": "Cette valeur sera appliquée à tous les équipements mesurés pour cette période de déclaration.",
    "noMeteredEquipmentUsageDataFound": "Aucune donnée d'utilisation d'équipement mesurée trouvée pour cette trimestre.",
    "noUsageDataFound": "Aucune donnée d'utilisation d'équipement trouvée pour cet équipement.",
    "operationDetails": "Détails de l'opération",
    "chargingCyclesShift": "Cycles de charge / Quart",
    "shiftsDay": "Quarts / Jour",
    "workDaysQuarter": "Jours de travail / Trimestre",
    "percentUptime": "Temps de disponibilité",
    "maxSiteDeliverabilityKw": "Puissance maximale du site (kW)",
    "chargerEfficiencyRating": "Taux d'efficacité du chargeur",
    "chargeReturnFactor": "Facteur de retour de charge",
    "depthOfDischarge": "Profondeur de décharge",
    "periodHasBeenLockedAndCannotBeEdited": "Cette période a été verrouillée et ne peut plus être modifiée.",
    "periodHasBeenFinalizedAndCanNoLongerBeEdited": "Cette période a été finalisée et ne peut plus être modifiée.",
    "whatAreYouChargingOrPowering": "Que chargez-vous ou alimentez-vous?",
    "equipmentCategory": "Catégorie d'équipement",
    "equipmentType": "Type d'équipement",
    "serialNumber": "Numéro de série",
    "nameplateRating": "Puissance nominale (kW)",
    "unitNumber": "Numéro d'unité",
    "chargingNetwork": "CNO/CMS",
    "forkliftClassification": "Classification de chariot élévateur",
    "firstActiveReportingPeriod": "Première période d'activité",
    "retireEquipment": "Retirer l'équipement",
    "deleteEquipment": "Supprimer l'équipement",
    "returnToFacility": "Retour à l'installation",
    "addNewEquipment": "Ajouter un nouvel équipement",
    "fseRegistrationStatus": "Statut d'enregistrement FSE",
    "approved": "Approuvé",
    "location": "Emplacement",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "createdBy": "Créé par",
    "createdAt": "Date de création",
    "equipmentUsage": "Utilisation de l'équipement",
    "saveUsage": "ENREGISTRER L'UTILISATION",
    "saveChangesTo": "Enregistrer les modifications à",
    "viewing": "Affichage",
    "pausedForSeasonality": "En pause pour saisonnalité",
    "fuelPathwayCode": "Code de voie de carburant",
    "filterByCode": "Filtrer par code...",
    "bookAndClaim": "Réserver et réclamer",
    "applied": "Appliqué",
    "notApplied": "Non appliqué",
    "batteryCapacityAh": "Capacité de la batterie (Ah)",
    "voltage": "Tension",
    "chargeCyclesShift": "Cycles de charge / Quarts",
    "usages": "Utilisations",
    "usage": "Utilisation",
    "usageDetails": "Détails d'utilisation",
    "category": "Catégorie",
    "type": "Type",
    "recsRequired": "RECs requis",
    "creditsGenerated": "Crédits générés",
    "kwhPerChargeCycle": "kWh / Cycle de charge",
    "retireWarning": "Avertissement : Le retrait de cet équipement supprimera toutes les données d'utilisation",
    "retireConfirmation": "Je comprends que toutes les données d'utilisation après {{period}} seront supprimées.",
    "retireMultipleConfirmation_one": "Je comprends que {{count}} équipement sélectionné sera retiré et que toutes les données d'utilisation après {{period}} seront supprimées.",
    "retireMultipleConfirmation_other": "Je comprends que {{count}} équipements sélectionnés seront retirés et que toutes les données d'utilisation après {{period}} seront supprimées.",
    "deleteMultipleConfirmation_one": "Je comprends que {{count}} équipement sélectionné sera supprimé définitivement et que cette action est irréversible.",
    "deleteMultipleConfirmation_other": "Je comprends que {{count}} équipements sélectionnés seront supprimés définitivement et que cette action est irréversible.",
    "firstDayInService": "Premier jour en service",
    "creatorDetails": "Détails du créateur"
  }
}
